import React, { useEffect, useMemo, useState } from "react";
import { StepUpSpinner } from "../../../Components/Loader";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Card,
  Typography,
} from "@mui/material";
import {
  useDeleteRescheduleMutation,
  useGetTeamQuery,
  useGetRescheduleQuery,
  useGetPositionQuery,
} from "../../../Api/attoDeskApi";
import {
  ITeam,
  IPosition,
  ScheduleEdit,
} from "../../../Api/Interface/api.interface";
import NewPopUpTeam from "../Edit/index";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import Pagination from "../../../Components/Pagination";
import { Avatar } from "@mui/material";
import AvatarImg from "../../../Images/avatar.png";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const capitalizeFirstLetter = (name: string) =>
  name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const [selectedCoursing, setSelectedCoursing] = useState<ScheduleEdit | null>(
    null
  );
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<ScheduleEdit | null>(
    null
  );
  const [selectedStartDate, setSelectedStartDate] = useState<Dayjs | undefined>(
    dayjs()
  );

  const { data, isLoading, isError, refetch } = useGetRescheduleQuery({
    searchText: "",
    startDate: selectedStartDate ? selectedStartDate.format("YYYY-MM-DD") : "",
  });

  const { data: positionData, isLoading: positionLoading } =
    useGetPositionQuery({
      searchText: "",
    });

  const { data: tenantData, isLoading: tenantIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const teamList = useMemo(() => {
    return tenantData?.data as ITeam[];
  }, [tenantData?.data]);

  const positionList = useMemo(() => {
    return positionData?.data as IPosition[];
  }, [positionData?.data]);

  const postionMap = useMemo(() => {
    const map = new Map();
    positionList?.forEach((category) => {
      map.set(category.id, category.positionName);
    });
    return map;
  }, [positionList]);

  const teamMap = useMemo(() => {
    const map = new Map<
      number,
      {
        name: string;
        image: string;
        hourlySalary: string;
        otHourlySalary: string;
        positionName: string | null;
      }
    >();

    teamList?.forEach((teamMember) => {
      const fullName = `${capitalizeFirstLetter(
        teamMember.teamFirstName || ""
      )} ${capitalizeFirstLetter(teamMember.teamLastName || "")}`.trim();
      const positionName = postionMap.get(teamMember.teamPositionId) || null;

      map.set(teamMember.id, {
        name: fullName,
        image: teamMember.teamImg,
        hourlySalary: teamMember.teamHourlySalary,
        otHourlySalary: teamMember.teamOtHourlySalary,
        positionName,
      });
    });

    return map;
  }, [teamList, postionMap]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleOpenDialog = (coursing: ScheduleEdit) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: ScheduleEdit) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteRescheduleMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the schedule");
    }
  };
  const handleStartDateChange = (newDate: Dayjs | null) => {
    setSelectedStartDate(newDate || undefined);
  };

  if (isLoading)
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                      <StepUpSpinner size="medium" />
                    </Box>
    );

  const coursings: ScheduleEdit[] = Array.isArray(data?.data)
    ? (data?.data as ScheduleEdit[])
    : [];

  const handleAddProductClick = () => {
    navigate("/re-Schedule/create");
  };

  return (
    <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        {/* <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Button
            variant="contained"
            className={classes.addButton}
            onClick={handleAddProductClick}
          >
            Add New
          </Button>
        </Grid> */}
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
            <Grid item>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={selectedStartDate}
                  onChange={handleStartDateChange}
                  className={classes.searchTextField}
                  slotProps={{
                    textField: {
                      placeholder: "Start Date",
                      size: "small",
                      sx: {
                        width: "140px",
                      },
                      InputProps: {
                        sx: {
                          fontSize: 14,
                        },
                        // classes: {
                        //   root: classes.textFieldQuote,
                        //   notchedOutline: classes.notchedOutline,
                        // },
                        classes: {
                          root: classes.formControlListStatus,
                        },
                      },
                      InputLabelProps: {
                        sx: {
                          fontSize: 14,
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item>
              <Button
                // variant="contained"
                className={classes.addNewButton}
                onClick={handleAddProductClick}
              >
                Add New
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        <TableContainer>
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader}>
                  <strong>Name</strong>
                </TableCell>
                <TableCell
                  className={classes.tablheader}
                  // sx={{ textAlign: "center" }}
                >
                  <strong>Position</strong>
                </TableCell>
                <TableCell
                  className={classes.tablheader}
                  // sx={{ textAlign: "center" }}
                >
                  <strong>Date</strong>
                </TableCell>
                <TableCell
                  className={classes.tablheader}
                  // sx={{ textAlign: "center" }}
                >
                  <strong>Starting Time</strong>
                </TableCell>
                <TableCell
                  className={classes.tablheader}
                  sx={{ textAlign: "right" }}
                >
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading || positionLoading || tenantIsLoading ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                      <StepUpSpinner size="medium" />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : isError || coursings.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                coursings
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: ScheduleEdit, index) => (
                    <TableRow key={row.id} className={classes.tableRowHover}>
                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {" "}
                        <Grid container spacing={1}>
                          <Grid
                            item
                            textAlign={"center"}
                            alignContent={"center"}
                          >
                            <Typography className={classes.nameTableList}>
                              {teamMap.get(row.empid)?.name || ""}
                            </Typography>
                          </Grid>
                        </Grid>
                      </TableCell>
                      <TableCell
                        scope="row"
                        className={classes.tablCell}
                        // sx={{ textAlign: "center" }}
                      >
                        {teamMap.get(row.empid)?.positionName}
                      </TableCell>
                      <TableCell
                        scope="row"
                        className={classes.tablCell}
                        // sx={{ textAlign: "center" }}
                      >
                        {dayjs(row.date).isValid()
                          ? dayjs(row.date).format("YYYY-MM-DD")
                          : "Invalid Date"}
                      </TableCell>
                      <TableCell
                        scope="row"
                        className={classes.tablCell}
                        // sx={{ textAlign: "center" }}
                      >
                        {formatTime(row.startTime)} - {formatTime(row.endTime)}
                        {row.spansNextDay == true && (
                          <span
                            style={{
                              color: "#e3791a",
                              fontWeight: 600,
                              lineHeight: 1.5,
                              fontSize: "0.875rem",
                              paddingLeft: "1px",
                            }}
                          >
                            [next day]
                          </span>
                        )}
                      </TableCell>

                      <TableCell scope="row" className={classes.tablCell}>
                        <Grid
                          container
                          spacing={1}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Grid item>
                            <Button
                              // variant="contained"
                              className={classes.editButtonList}
                              onClick={() => handleOpenDialog(row)}
                            >
                              <EditSharpIcon className={classes.editListIcon} />
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              // variant="contained"
                              className={classes.deleteButtonList}
                              onClick={() => handleOpenDeletePopup(row)}
                            >
                              <DeleteOutlineSharpIcon
                                className={classes.deleteListIcon}
                              />
                            </Button>
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
          {/* <Grid
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={coursings.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid> */}
        </TableContainer>
        {selectedCoursing && (
          <NewPopUpTeam
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            data={selectedCoursing}
          />
        )}
        {coursingToDelete && (
          <DeletePopup
            open={openDeleteCategory}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(coursingToDelete.id.toString());
            }}
            title="Delete Schedule"
            content={`Are you sure you want to delete "${
              teamMap.get(coursingToDelete.empid)?.name || ""
            }"?`}
          />
        )}
      </Grid>
    </Card>
  );
};

export default Index;
